export default "__VITE_ASSET__DqluC2pl__"